module.exports = __webpack_public_path__ + "img/set-goals-180.5743bdb.svg";